// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders_content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 18px 24px 24px 0;
	gap: 24px;
}

.orders_header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 160px;
	gap: 16px;
}

.orders__buttons-wrapper {
	display: flex;
	align-items: center;
	gap: 16px;
}

.orders_content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 12px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
}

.orders__page-filters {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.orders__page-title {
	font-size: 20px;
	line-height: 25px;
	font-weight: 500;
	color: #191919;
}

.orders__page-filters-wrapper {
	position: relative;
}

.orders__page-filters-button {
	width: 44px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border-radius: 6px;
	cursor: pointer;
	transition: 0.3s;
	border: 1px solid #e6e6e6;
}

.orders__page-filters-button.expanded {
	background-color: #4db8ff;
	transition: 0.3s;
}

.orders__page-filters-actions {
	display: flex;
	align-items: center;
	gap: 16px;
}

.orders__table-wrapper {
	background-color: #ffffff;
	padding: 12px;
	border-radius: 10px;
}

.orders__table-wrapper tr {
	height: 64px;
}

.orders__table-wrapper tr th {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
	font-weight: 400;
}

.orders__table-wrapper tr td {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 400;
}

.orders__order-status-color {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	min-width: 10px;
}

.orders__order-status-color.paid {
	background-color: #117627;
}

.orders__order-status-color.not-paid {
	background-color: #d82323;
}

.orders__order-status-color.refunded {
	background-color:rgb(239, 239, 81);
}

.orders__dropdown-button {
	border: 1px solid #e6e6e6;
	padding: 0 12px;
	height: 44px;
	border-radius: 8px;
	background-color: #ffffff;
	color: #191919;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}

.orders__dropdown-toggle img {
	transition: 0.3s;
}

.orders__dropdown-toggle.show img {
	transform: rotate(180deg);
	transition: 0.3s;
}

.orders__dropdown-menu-wrapper {
	padding: 8px;
	border: 1px solid #e6e6e6;
}

.orders__dropdown-menu {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.orders__dropdown-item {
	width: 100%;
	height: 40px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	padding: 0 10px;
	font-size: 16px;
	line-height: 20px;
	color: #666666 !important;
}

.orders__dropdown-item:hover {
	background-color: #f2f2f2 !important;
}

.orders-nav-links .active::before {
	position: absolute;
	height: 2px;
	width: 80%;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	content: "";
	background: #1c6fd1;
	transition: width 0.4s;
	color: #1c6fd1 !important;
}

.orders-nav-links .active {
	color: unset !important;
	font-weight: unset !important;
}

.orders-nav-links .nav-link:hover {
	color: #1c6fd1 !important;
}

.dashboard-status-color {
	width: 10px;
	height: 10px;
	background: #55bb56;
	margin: 3px 0px 0px 4px;
	border-radius: 50%;
}

.bg-success {
	background-color: #28a745 !important;
}

.order-status-circle {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: green;
	border-radius: 100%;
	cursor: pointer;
}

.order-status-circle.success {
	background-color: green;
}

.order-status-circle.pending_synchronization {
	background-color: #4e61f4;
}

.order-status-circle.synchronization_failed,
.order-status-circle.status_update_failed,
.order-status-circle.failed {
	background-color: red;
}

.no-styles-button {
	background: none;
	border: none;
	cursor: pointer;
}

.order-status-overlay {
	max-width: 380px;
	background: rgb(20, 20, 20);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	padding: 4px 12px;
	border-radius: 8px;
	font-size: 14px;
}

.upload-orders__description {
	font-size: 16px;
	line-height: 22px;
	color: #666666;
}

.order-details__choose-action {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.orders__table-header-with-sort {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: 0.2s;
}

.orders__table-header-with-sort.centered {
	justify-content: center;
}

.orders__table-header-with-sort:hover {
	color: #4e61f4;
	transition: 0.2s;
}

.orders__table-header-with-sort svg {
	transition: 0.2s;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/Orders/Orders.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;AACT;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,SAAS;CACT,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB","sourcesContent":[".orders_content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 18px 24px 24px 0;\n\tgap: 24px;\n}\n\n.orders_header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-right: 160px;\n\tgap: 16px;\n}\n\n.orders__buttons-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.orders_content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 12px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n}\n\n.orders__page-filters {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n}\n\n.orders__page-title {\n\tfont-size: 20px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.orders__page-filters-wrapper {\n\tposition: relative;\n}\n\n.orders__page-filters-button {\n\twidth: 44px;\n\theight: 44px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: #ffffff;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\ttransition: 0.3s;\n\tborder: 1px solid #e6e6e6;\n}\n\n.orders__page-filters-button.expanded {\n\tbackground-color: #4db8ff;\n\ttransition: 0.3s;\n}\n\n.orders__page-filters-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.orders__table-wrapper {\n\tbackground-color: #ffffff;\n\tpadding: 12px;\n\tborder-radius: 10px;\n}\n\n.orders__table-wrapper tr {\n\theight: 64px;\n}\n\n.orders__table-wrapper tr th {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n\tfont-weight: 400;\n}\n\n.orders__table-wrapper tr td {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 400;\n}\n\n.orders__order-status-color {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n\tmin-width: 10px;\n}\n\n.orders__order-status-color.paid {\n\tbackground-color: #117627;\n}\n\n.orders__order-status-color.not-paid {\n\tbackground-color: #d82323;\n}\n\n.orders__order-status-color.refunded {\n\tbackground-color:rgb(239, 239, 81);\n}\n\n.orders__dropdown-button {\n\tborder: 1px solid #e6e6e6;\n\tpadding: 0 12px;\n\theight: 44px;\n\tborder-radius: 8px;\n\tbackground-color: #ffffff;\n\tcolor: #191919;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n}\n\n.orders__dropdown-toggle img {\n\ttransition: 0.3s;\n}\n\n.orders__dropdown-toggle.show img {\n\ttransform: rotate(180deg);\n\ttransition: 0.3s;\n}\n\n.orders__dropdown-menu-wrapper {\n\tpadding: 8px;\n\tborder: 1px solid #e6e6e6;\n}\n\n.orders__dropdown-menu {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.orders__dropdown-item {\n\twidth: 100%;\n\theight: 40px;\n\tborder-radius: 6px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666 !important;\n}\n\n.orders__dropdown-item:hover {\n\tbackground-color: #f2f2f2 !important;\n}\n\n.orders-nav-links .active::before {\n\tposition: absolute;\n\theight: 2px;\n\twidth: 80%;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tmargin: auto;\n\tcontent: \"\";\n\tbackground: #1c6fd1;\n\ttransition: width 0.4s;\n\tcolor: #1c6fd1 !important;\n}\n\n.orders-nav-links .active {\n\tcolor: unset !important;\n\tfont-weight: unset !important;\n}\n\n.orders-nav-links .nav-link:hover {\n\tcolor: #1c6fd1 !important;\n}\n\n.dashboard-status-color {\n\twidth: 10px;\n\theight: 10px;\n\tbackground: #55bb56;\n\tmargin: 3px 0px 0px 4px;\n\tborder-radius: 50%;\n}\n\n.bg-success {\n\tbackground-color: #28a745 !important;\n}\n\n.order-status-circle {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n\tbackground-color: green;\n\tborder-radius: 100%;\n\tcursor: pointer;\n}\n\n.order-status-circle.success {\n\tbackground-color: green;\n}\n\n.order-status-circle.pending_synchronization {\n\tbackground-color: #4e61f4;\n}\n\n.order-status-circle.synchronization_failed,\n.order-status-circle.status_update_failed,\n.order-status-circle.failed {\n\tbackground-color: red;\n}\n\n.no-styles-button {\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n}\n\n.order-status-overlay {\n\tmax-width: 380px;\n\tbackground: rgb(20, 20, 20);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: white;\n\tpadding: 4px 12px;\n\tborder-radius: 8px;\n\tfont-size: 14px;\n}\n\n.upload-orders__description {\n\tfont-size: 16px;\n\tline-height: 22px;\n\tcolor: #666666;\n}\n\n.order-details__choose-action {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n}\n\n.orders__table-header-with-sort {\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\ttransition: 0.2s;\n}\n\n.orders__table-header-with-sort.centered {\n\tjustify-content: center;\n}\n\n.orders__table-header-with-sort:hover {\n\tcolor: #4e61f4;\n\ttransition: 0.2s;\n}\n\n.orders__table-header-with-sort svg {\n\ttransition: 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
